export function shouldBeDisplay(key, page, genaralCustom) {
  let a = genaralCustom?.find((item) => item.value === key);
  return a?.enabled;
}
